<template>
  <div>
    <div class="d-flex align-center mb-2">
      <div class="text-h6 font-weight-bold">Browse</div>
      <v-spacer />
      <v-btn text small @click="clear">Clear</v-btn>
    </div>

    <v-chip v-if="selectedDepartment" close @click:close="$emit('update:selectedDepartment', null)">
      {{ selectedDepartment }}
    </v-chip>

    <v-row dense class="mt-2">
      <v-col v-for="p in filtered" :key="p.id" cols="6" sm="4" md="3" lg="2">
        <ProductCard
          :product="p"
          :qty="cartQty(p.id)"
          @add="$emit('add', p)"
          @inc="$emit('inc', p.id)"
          @dec="$emit('dec', p.id)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ProductCard from "../components/ProductCard.vue";

export default {
  name: "RemoteStoreBrowse",
  components: { ProductCard },
  props: {
    products: { type: Array, default: () => [] },
    search: { type: String, default: "" },
    selectedDepartment: { type: String, default: null },
    cart: { type: Object, default: () => ({}) },
  },
  computed: {
    filtered() {
      const s = (this.search || "").trim().toLowerCase();
      return (this.products || [])
        .filter((p) => {
          if (this.selectedDepartment) {
            const d = p.Department?.name || "Unassigned";
            if (d !== this.selectedDepartment) return false;
          }
          if (!s) return true;

          const brand = p.Brand?.name || "";
          const dept = p.Department?.name || "";
          const cat = p.Category?.name || "";

          return (
            (p.name || "").toLowerCase().includes(s) ||
            brand.toLowerCase().includes(s) ||
            dept.toLowerCase().includes(s) ||
            cat.toLowerCase().includes(s) ||
            String(p.sku || "").toLowerCase().includes(s) ||
            String(p.upc || "").toLowerCase().includes(s)
          );
        })
        .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
    },
  },
  methods: {
    cartQty(id) {
      return Number(this.cart[String(id)] || 0);
    },
    clear() {
      this.$emit("update:selectedDepartment", null);
      // search is owned by Shell, keep it there for now
    },
  },
};
</script>